/**
* 用户管理 用户列表
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" style="margin-top: 20px;">
      <el-form-item>
        <el-input size="small" v-model="keyword" placeholder="请输入用户手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="nickName" placeholder="请输入用户昵称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="nickid" placeholder="请输入用户id"></el-input>
      </el-form-item>
      <!-- <el-form-item label="审核状态：">
        <el-select size="small" v-model="status" placeholder="请选择审核状态">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="chongzhi">重置</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;" v-horizontal-scroll>
      <el-table-column align="center" sortable type="index" label="序号"></el-table-column>
      <el-table-column align="center" prop="id" label="id" width="70" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" prop="mobile" label="手机号" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="avatar" label="头像" width="120">
        <template slot-scope="scope">
          <el-image v-if="scope.row.avatar" style="width: 40px;height: 40px;" :src="scope.row.avatar"
            :preview-src-list="[scope.row.avatar]" />
          <div v-if="scope.row.avatar == null">暂无图片</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="nickName" label="用户昵称" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="sex" label="性别" width="70" :formatter="sexf" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column align="center" prop="status" label="状态" width="120" :formatter="zhuangTai" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column align="center" prop="currentCirclesName" label="圈层名称" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="currentPyramidName" label="金字塔名" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="starMoney" label="奖学金" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="masonryMoney" label="钻石" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="birthday" label="生日" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="area" label="地区" width="120" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column align="center" prop="grade" label="年级" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="cassPositions" label="班级职位" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="expectUniversity" label="期望大学" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="inUniversity" label="在读学校" width="120" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column align="center" prop="thumbsUp" label="点赞数" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="concernNum" label="关注数" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="fanNum" label="粉丝数" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间" width="150">
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="updateTime" label="更新时间" width="150" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.updateTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" show-overflow-tooltip width="400px" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="openGongsi(scope.row)">公司详情</el-button>
          <el-button size="mini" type="primary" @click="openQuanceng(scope.row)">圈层详情</el-button>
          <!-- <el-button size="mini" type="primary" @click="updateYes(scope.row)">审核通过</el-button>
          <el-button size="mini" type="danger" @click="updateNo(scope.row)">审核不通过</el-button> -->
          <el-button size="mini" type="primary" @click="upUserYes(scope.row)">用户启用</el-button>
          <el-button size="mini" type="danger" @click="upUserNo(scope.row)">用户禁用</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 用户圈层详情页 -->
    <el-dialog title="用户圈层详情页：" :visible.sync="editFormDetails" width="60%">
      <el-table size="small" :data="QCData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
        style="width: 100%;">
        <el-table-column align="center" sortable prop="grade" label="等级"></el-table-column>
        <el-table-column align="center" sortable prop="name" label="圈层名称"></el-table-column>
        <el-table-column align="center" sortable prop="description" label="描述"></el-table-column>
        <el-table-column align="center" sortable prop="amount" label="金额"></el-table-column>
        <el-table-column align="center" sortable prop="money" label="奖学金"></el-table-column>
        <el-table-column align="center" sortable prop="createTime" label="创建时间">
          <template slot-scope="scope">
            <div>{{ transformDate(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="XiugaiQC(scope.row)"
              v-if="scope.row.isBuy === 0">开通圈层</el-button>
            <el-button size="mini" type="success" v-if="scope.row.isBuy === 1">已开通</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 公司详情 -->
    <el-dialog title="用户公司详情页：" :visible.sync="editFormDetailsGS" width="80%">
      <el-table size="small" :data="Gongsi" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
        style="width: 100%;">
        <el-table-column align="center" sortable prop="currentName" label="当前所在层级数" width="180"></el-table-column>
        <el-table-column align="center" sortable prop="image" label="策划书图片">
          <template slot-scope="scope">
            <el-image v-if="scope.row.image" style="width: 90px;height: 90px;" :src="scope.row.image"
              :preview-src-list="[scope.row.image]" />
          </template>
        </el-table-column>
        <el-table-column align="center" sortable prop="size" label="人数"></el-table-column>
        <el-table-column align="center" sortable prop="depart" label="部门"></el-table-column>
        <el-table-column align="center" sortable prop="data" label="资料">
          <template slot-scope="scope">
            <el-image v-if="scope.row.data" style="width: 90px;height: 90px;" :src="scope.row.data"
              :preview-src-list="[scope.row.data]" />
          </template>
        </el-table-column>
        <el-table-column align="center" sortable prop="tax" label="税收"></el-table-column>
        <el-table-column align="center" sortable prop="registered" label="缴纳注册资本金" width="180"></el-table-column>
        <el-table-column align="center" sortable prop="salary" label="合计工资"></el-table-column>
        <el-table-column align="center" sortable prop="createTime" label="创建时间" width="180">
          <template slot-scope="scope">
            <div>{{ transformDate(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

  </div>
</template>

<script>
import {
  getUserList,
  aduitUser,
  updateUserStatus,
  getUserCirclesList,
  openCircles,
  getUserCompanyRecoordList,
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";


// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image", "video"], // 对于图片上传这是重点
  ["clean"], // remove formatting button
];


export default {
  data() {
    return {
      uploadVisible: false,
      cursorIndex: 0,
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: (value) => {
                if (value) {
                  // 在这里编写图片按钮点击操作
                  this.uploadVisible = true;
                  this.cursorIndex =
                    this.$refs.QuillEditor.quill.getSelection().index;
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      statusType: [
        { key: '请选择', value: 0 },
        { key: '正常', value: 1 },
        { key: '冻结', value: 2 }
      ],

      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      },

      keyword: "",
      nickName: "",
      nickid: "",
      status: -1,
      from: {
        title: "",
        briefContent: "",
        content: "",
        userId: "",
        sendType: 0,
      },
      options: [{
        value: -1,
        label: '全部'
      },
      {
        value: 0,
        label: '审核中'
      }, {
        value: 1,
        label: '审核通过'
      }, {
        value: 2,
        label: '审核未通过'
      }],
      editFormDetails: false,
      QCData: [],
      Gongsi: [],
      editFormDetailsGS: false,
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(1)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 开通圈层
    XiugaiQC(row) {
      this.$confirm("确定开通此圈层吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      }).then(() => {
        let data = {
          userId: this.userId,
          circlesId: row.id,
        }
        openCircles(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
        })

      }).catch((err) => {
        this.$message({
          type: "info",
          message: "已取消开通",
        });
      });
    },
    // 查看公司详情页
    openGongsi(row) {
      this.editFormDetailsGS = true;
      let data = {
        userId: row.id
      }
      getUserCompanyRecoordList(data).then((res) => {
        this.loading = false;
        if (res.code != 200) {
          this.$Message({
            type: "info",
            message: res.msg
          });
        } else {
          this.Gongsi = res.data.list;
          return;
        }
      })
    },
    // 查看用户圈层详情页
    openQuanceng(row) {
      this.loading = true;
      this.editFormDetails = true;
      this.userId = row.id;
      let data = {
        userId: row.id
      }
      getUserCirclesList(data).then((res) => {
        this.loading = false;
        if (res.code != 200) {
          this.$Message({
            type: "info",
            message: res.msg
          });
        } else {
          this.QCData = res.data.list;
          return;
        }
      })
    },
    // 启用用户
    upUserYes(row) {
      console.log('row', row)
      this.$confirm("确定启用此用户吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      }).then(() => {
        let data = {
          id: row.id,
          status: 1
        }
        updateUserStatus(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.getdata(1)
          } else {
            this.$message.error(res.msg)
          }
        })

      }).catch((err) => {
        this.$message({
          type: "info",
          message: "已取消启用",
        });
      });
    },
    // 禁用用户
    upUserNo(row) {
      this.$confirm("确定禁用此用户吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      }).then(() => {
        let data = {
          id: row.id,
          status: 2
        }
        updateUserStatus(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.getdata(1)
          } else {
            this.$message.error(res.msg)
          }
        })

      }).catch((err) => {
        this.$message({
          type: "info",
          message: "已取消禁用",
        });
      });
    },
    // 审核通过
    updateYes(row) {
      console.log('row', row)
      this.$confirm("确定通过吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      }).then(() => {
        let data = {
          id: row.id,
          status: 1
        }
        aduitUser(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.getdata(1)
          } else {
            this.$message.error(res.msg)
          }
        })

      }).catch((err) => {
        this.$message({
          type: "info",
          message: "已取消通过",
        });
      });
    },

    // 审核不通过
    updateNo(row) {
      console.log('row', row)
      this.$confirm("确定不通过吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      }).then(() => {
        let data = {
          id: row.id,
          status: 2
        }
        aduitUser(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.getdata(1)
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch((err) => {
        this.$message({
          type: "info",
          message: "已取消不通过",
        });
      });
    },


    selectChange(e) {
      console.log('e======', e)
      this.getdata(1)
    },

    sexf: function (row) {
      if (row.sex == 1) {
        return "男"
      } else {
        return "女"
      }
    },

    zhuangTai: function (row) {
      if (row.status == 0) {
        return "审核中"
      } else if (row.status == 1) {
        return "审核通过"
      } else if (row.status == 2) {
        return "审核未通过"
      }
    },

    // 获取数据方法
    getdata(page) {
      this.loading = true;
      var parameter = {
        mobile: this.keyword,
        // status: this.status,
        nickName: this.nickName,
        id: this.nickid,
        page: (page - 1) * 20,
      };
      getUserList(parameter).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = res.data.list;
          this.pageparm.currentPage = page;
          this.pageparm.total = res.data.count;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },

    // 修改状态值


    // 分页插件事件
    callFather(parm) {
      this.pageparm.page = parm.currentPage
      this.getdata(parm.currentPage)
    },
    // 搜索事件
    search() {
      this.getdata(1)
    },
    // 重置数据
    chongzhi() {
      this.keyword = ''
      this.status = -1
      this.nickName = ''
      this.nickid = ''
      this.getdata(1)
    },
  }
}
</script>

<style scoped>
.userRole {
  width: 100%;

}
</style>


// WEBPACK FOOTER //
// src/views/user/User.vue